import { useAxios } from './axiosService';

export const useJobService = () => {
    const { axios } = useAxios();

    const getIds = jobs => {
        const { ids } = jobs.reduce(
            (acc, job) => {
                acc.ids.push(job.id);
                return acc;
            },
            { ids: [] }
        );
        return ids;
    };

    const getJobs = async ({ currentPage, pageSize, search, status, reportType, internalDb, sortField, sortJob }) => {
        return await axios.get('/jobs', {
            params: {
                offset: (currentPage - 1) * pageSize,
                limit: pageSize,
                search,
                status,
                reportType,
                internalDb,
                sortField,
                sortJob,
            },
        });
    };

    const getJobByUuid = async uuid => {
        const res = await axios.get(`/jobs/${uuid}?isWatermarked=false`);
        return res.data;
    };

    const createJob = async body => {
        await axios.post('/jobs', body);
    };
    const updateJob = async (id, body) => {
        const res = await axios.put(`/jobs/${id}`, body);
        return res.data;
    };

    const deleteJob = async id => {
        const ids = getIds(id);
        await axios.delete(`/jobs`, { data: { ids } });
    };

    const getStatuses = async () => {
        return await axios.get(`/jobs/statuses`);
    };

    const changeJobsStatus = async (ids, statusId) => {
        // the Orders page shows its own message for a job another dealer took first (SC-QA-127)
        const response = await axios.put('/jobs/change-status', { ids, statusId }, { handledStatuses: [409] });

        return response.data;
    };

    const getJobLogs = async (id, skip, take) => {
        const response = await axios.get(`/jobs/logs/${id}?skip=${skip}&take=${take}`);

        return response.data;
    };

    const uploadFile = async (path, file, config) => {
        return await axios.post(`/jobs/files`, file, config);
    };

    const getFilesNames = async id => {
        const response = await axios.get(`/jobs/files/${id}`);

        return response.data;
    };

    const deleteFile = async (path, fileName, config) => {
        return await axios.delete(`/jobs/${path}/${fileName}`, config);
    };

    const getFile = async fileName => {
        return await axios.get(`/jobs/files/file/${fileName}`);
    };

    const regenerateReport = async jobUuid => {
        return await axios.post(`/report/regenerate-report/${jobUuid}`).then(res => res.data);
    };

    return {
        getJobs,
        getJobByUuid,
        createJob,
        updateJob,
        deleteJob,
        getStatuses,
        changeJobsStatus,
        getJobLogs,
        uploadFile,
        getFilesNames,
        deleteFile,
        getFile,
        regenerateReport,
    };
};
